import React from 'react';

import type { RicosEditorProps } from './../../ricos-common';
import type { RicosServices } from './../../ricos-types';

type RicosErrorBoundaryProps = React.PropsWithChildren & {
  editor?: RicosServices['editor'];
  onError: RicosEditorProps['onError'];
};

type RicosErrorBoundaryState = {
  error: string;
};

export class RicosErrorBoundary extends React.Component<
  RicosErrorBoundaryProps,
  RicosErrorBoundaryState
> {
  state = { error: '' };

  static getDerivedStateFromError(error: string) {
    return { error };
  }

  componentDidCatch(error: $TSFixMe, errorInfo: $TSFixMe) {
    if (this.props.editor) {
      this.props.editor.publishError(error, errorInfo);
    } else {
      console.error('Error inside Ricos', error, errorInfo);
    }
  }

  render() {
    try {
      if (this.state.error) {
        this.props.onError?.(this.state.error);
        return null;
      }

      return this.props.children;
    } catch (e) {
      // @ts-ignore $TSFixMe
      this.props.onError?.(e);
      return null;
    }
  }
}
